var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"height":"100%"}},[_c('iframe',{key:'iflink-iframe',staticStyle:{"width":"100%","height":"100%","border":"0px"},attrs:{"src":_vm.iflink}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }